import {TheRave} from "../TheRave";
import {TheRaveSymbolConfig, TheRaveSymbolState} from "./TheRaveSymbolConfig";
import {IParsedStackedSymbolName} from "../../core/reel/stackedsymbol/StackedSymbol";
import {IBaseSymbol} from "../../core/symbol/BaseSymbol";
import {TimelineLite, TweenLite, Power3} from "gsap";
import {FontStyleConfig} from "../config/FontConfig";
import {BitmapTextStyleOptions} from "../coutup/BitmapCountUp";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {TheRaveHelper} from "../utils/TheRaveHelper";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export interface ISymbolPart {
    bg: PIXI.Sprite;
    light: PIXI.Sprite;
    part: PIXI.Sprite;
    multiplierStyle: BitmapTextStyleOptions;
    multipliers: PIXI.BitmapText[];
}

export class TheRaveSymbol extends PIXI.Container implements IBaseSymbol {
    public symbolWidth: number = 144;
    public symbolHeight: number = 150;
    public bottomPadding: number = 0;

    protected _splitSplashDelay: number = 0.1;
    protected _splitSymbolAnimationDuration: number = 0.134;

    public symbolName: string;
    public stackedSymbolName: IParsedStackedSymbolName;
    public reelId: number;
    public symbolSize: number = 1;

    protected _centerPosition: PIXI.Point;
    protected _highLight: PIXI.Sprite;
    protected _transformAnimation: PIXI.spine.Spine;
    private _updateHeight: boolean;
    private _symbolMultiplier: number = 1;
    protected _symbolPart: ISymbolPart;
    protected _linkedSymbolNum: number = 1;
    protected _linkedSymbolPart: ISymbolPart[] = [];

    // tmp
    public isFullWild: boolean = false;
    public curMpValue: number = 0;
    protected numberBmps: PIXI.BitmapText [] = [];

    public get symbolStep(): number {
        return this.symbolHeight + this.bottomPadding;
    }

    public set symbolMultiplier(value: number) {
        this._symbolMultiplier = value;
    }

    public set linkedNumber(value: number) {
        this._linkedSymbolNum = value;
    }

    public get destroyed(): boolean {
        return this._destroyed;
    }

    constructor(symbolName: string, reelId: number, initState: TheRaveSymbolState, symHeight: number = 150, linkedNum: number = 1, fullWild: boolean = false) {
        super();
        this.isFullWild = fullWild;
        this.symbolName = symbolName;
        this.symbolHeight = (fullWild) ? 450 : symHeight;
        this._updateHeight = false;
        this.linkedNumber = linkedNum;
        this.reelId = reelId;
        if (TheRaveSymbolConfig.SYMBOLS[symbolName]?.symbolHeightFactor) {
            if (!this.isFullWild) {
                this.symbolHeight *= TheRaveSymbolConfig.SYMBOLS[symbolName].symbolHeightFactor!;
            }
        }
        this.initAnimation();
        this.getStateAnimation(initState, {duration: 0}, {duration: 0});
        this._highLight = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._highLight.width = this.symbolWidth;
        this._highLight.anchor.set(0.5, 0.5);
        this._highLight.name = "symbolHighLight";
    }

    protected initAnimation(): void {
        this._centerPosition = this.getCenterPosition();
        this._symbolPart = this.createSymbolPart();
    }

    public  showMultiplier(symbolSize:number):void {
        let numberSprite:PIXI.BitmapText;
        this.curMpValue = symbolSize;

        this.numberBmps.forEach((sprite:PIXI.BitmapText) => {
            //debugger;
            if(sprite.text === "x" + symbolSize){
                numberSprite = sprite;
                numberSprite.visible = true;
            }
            //console.log(sprite.name, "x" + symbolSize)
        });
    }

    private createSingleSymbolPart(index: number = 0): ISymbolPart {
        const bg = new PIXI.Sprite();
        if (this.hasBg()) {
            const bgName: string = `${this.symbolName}/${this.symbolName}_bg`;
            bg.texture = TheRave.assetLoader.getTextures(bgName)[0];
            bg.name = bgName;
            bg.x = 72 * index * 2;
            bg.y = 0;
            bg.anchor.set(0.5, 0.5);
        }
        const symbolSprite = new PIXI.Sprite();
        symbolSprite.x = 144 * index;
        symbolSprite.y = 0;
        symbolSprite.anchor.set(0.5, 0.5);
        this.addChild(bg);
        const light = new PIXI.Sprite();
        light.x = 144 * index;
        light.y = 0;
        light.anchor.set(0.5, 0.5);
        const multiplierContainer: PIXI.Sprite = new PIXI.Sprite();
        multiplierContainer.position.set(this._centerPosition.x, this._centerPosition.y);
        const multipliers: PIXI.BitmapText[] = [];

        this.addChild(light);
        this.addChild(symbolSprite);
        return {
            bg: bg,
            light: light,
            part: symbolSprite,
            multiplierStyle: FontStyleConfig.SYMBOL_MULTIPLIER,
            multipliers: multipliers
        };
    }

    private createLinkedSingleSymbolPart(index: number): ISymbolPart {
        const bg = new PIXI.Sprite(),
        leftReelOffset:number = this.reelId - TheRave.reels[this.reelId].mostLeftReel;
        let left:number = leftReelOffset*144 + (index <=leftReelOffset?144:0);
        if (this.hasBg()) {
            const bgName: string = `${this.symbolName}/${this.symbolName}_bg`;
            bg.texture = TheRave.assetLoader.getTextures(bgName)[0];
            bg.name = bgName;
            bg.x = 72 * index * 2 - left;
            bg.y = 0;
            bg.anchor.set(0.5, 0.5);
        }
        const symbolSprite = new PIXI.Sprite();
        symbolSprite.x = 144 * index-left;
        symbolSprite.y = 0;
        symbolSprite.anchor.set(0.5, 0.5);
        this.addChild(bg);
        const light = new PIXI.Sprite();
        light.x = 144 * index-left;
        light.y = 0;
        light.anchor.set(0.5, 0.5);
        const multiplierContainer: PIXI.Sprite = new PIXI.Sprite();
        multiplierContainer.position.set(this._centerPosition.x, this._centerPosition.y);
        const multipliers: PIXI.BitmapText[] = [];

        this.addChild(light);
        this.addChild(symbolSprite);
        return {
            bg: bg,
            light: light,
            part: symbolSprite,
            multiplierStyle: FontStyleConfig.SYMBOL_MULTIPLIER,
            multipliers: multipliers
        };
    }

    private createSymbolPart(): ISymbolPart {
        const symbolPart: ISymbolPart = this.createSingleSymbolPart(0);
        for (let i: number = 1; i < this._linkedSymbolNum; i++) {
            this._linkedSymbolPart.push(this.createLinkedSingleSymbolPart(i));
        }
        return symbolPart;
    }

    private removeSymbolPart(part: ISymbolPart): void {
        this.removeChild(part.part);
        part.part.destroy();
        part.multipliers.forEach((multiplier: PIXI.BitmapText) => multiplier.destroy());
        this._linkedSymbolPart.forEach((linkedSymbolPart: ISymbolPart) => {
            linkedSymbolPart.part.destroy();
        });
        this._linkedSymbolPart = [];
        this.linkedNumber = 1;
    }

    protected getCenterPosition(): PIXI.Point {
        return new PIXI.Point(0, 0);
    }

    public getStateAnimation(state: TheRaveSymbolState, inVars: gsap.TweenVars, outVars: gsap.TweenVars, frames?: number[]): TimelineLite {
        // TODO: check the state config?
        this.createState(state);
        return new TimelineLite();
    }

    public playLanding(init: boolean = false, reelId: number = -1, symbolName:string = "", symId:number = 0): TimelineLite {
        const tl:TimelineLite = new TimelineLite();
       // if(TheRave.model.parsedGameData.isFreespin && symbolName === "XW") {
            // TODO
            //tl.add(TheRave.xwaysEqView.playXwayGlow(reelId, () => {}, true, symId));
        //}

        return tl;
    }

    public playHighLight(isQuickSpin: boolean = false): TimelineLite {
        this._highLight.height = this.symbolHeight;
        this._symbolPart.part.addChild(this._highLight);
        return new TimelineLite().add(TweenLite.fromTo(this._highLight, isQuickSpin ? 0.1 : 0.2, {alpha: 0.4}, {
            alpha: 0.4
        })).add(TweenLite.to(this._highLight, isQuickSpin ? 0.1 : 0, {
            alpha: 0,
            ease: Power3.easeOut
        }));
    }

    public playWildBlink(): void {
        const wildText:PIXI.Sprite = new PIXI.Sprite(TheRave.assetLoader.getTextures("wild/wild")[0]);
        this._symbolPart.part.addChild(wildText);
        wildText.anchor.set(0.5,0.5);
        TweenLite.to(wildText,0.4, {alpha: 0, ease: Power3.easeOut, delay:0.3});
    }

    public playTransform(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            transformAnimation: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`SYMTRANSFORM`));
        transformAnimation.name = `transformAnimation`;

        tl.add(() => {
            this.alpha = 1;
            this._symbolPart.part.alpha = 0.8;
            this._symbolPart.bg.alpha = 0.8;
            //TheRaveSound.playSoundEffect(TheRaveSound.XWAY_SYMBOL_LANDING);
            transformAnimation.state.setAnimation(0, this.symbolHeight === 75?"75px":"animation", false);
            this.addChild(transformAnimation);
        }, 0);
        tl.add([
            TweenLite.fromTo(this._symbolPart.part, 0.334, {alpha: 0}, {alpha: 1}),
            TweenLite.fromTo(this._symbolPart.bg, 0.334, {alpha: 0}, {alpha: 1})
        ], 0.233);
        tl.add(() => {
            this.removeChild(transformAnimation);
        }, 0.767);
        return tl;
    }

    protected createState(state: TheRaveSymbolState): void {
        this.addChild(this._symbolPart.part);
        this._symbolPart.part.texture = this.getStateTexture(state)[0];
        this._linkedSymbolPart.forEach((symPart) => {
            this.addChild(symPart.part);
            symPart.part.texture = this.getLinkedSymStateTexture(symPart, state)[0];
        });
    }

    public updateTexture(): void {
        this._symbolPart.part.texture = this.getStateTexture()[0];
        this._linkedSymbolPart.forEach((symPart) => symPart.part.texture = this.getLinkedSymStateTexture(symPart)[0]);
    }

    protected getLinkedSymStateTexture(symPart: ISymbolPart, state?: TheRaveSymbolState): PIXI.Texture[] {
        symPart.bg.visible = false;
        let texturePath = `${this.symbolName}/${this.symbolName}`;
        if (this.symbolName === "X") {
            return TheRave.assetLoader.getTextures(texturePath);
        }

        if (state === TheRaveSymbolState.SPIN) {
            return TheRave.assetLoader.getTextures(texturePath + "_spin");
        }

        texturePath += `_${this.symbolHeight}_${this.symbolSize}`;
        if (this.hasBg()) {
            symPart.bg.scale.y = this.symbolHeight / 150;
            symPart.bg.visible = true;
        }

        return TheRave.assetLoader.getTextures(texturePath);
    }

    protected getStateTexture(state?: TheRaveSymbolState): PIXI.Texture[] {
        if (this.isFullWild) {
            if(this.curMpValue > 0) {
                this.showMultiplier(this.curMpValue);
            }
            return [ImgLoader.getImgTexture("dxWild")];
        } else {
            this._symbolPart.bg.visible = false;
            let texturePath = `${this.symbolName}/${this.symbolName}`;
            if (this.symbolName === "X") {
                return TheRave.assetLoader.getTextures(texturePath);
            }

            if (state === TheRaveSymbolState.SPIN) {
                return TheRave.assetLoader.getTextures(texturePath + "_spin");
            }

            texturePath += `_${this.symbolHeight}_${this.symbolSize}`;
            if (this.hasBg()) {
                this._symbolPart.bg.scale.y = this.symbolHeight / 150;
                this._symbolPart.bg.visible = true;
            }
            if (TheRave.apiPlugin.gameClientConfiguration.useCensoredGfxUS && texturePath === "M1/M1_300_1") {
                texturePath += "_US";
            }

            // TODO: Ugly temporary hack to circumvent texture error

            return (texturePath === "W/W_450_1")? [ImgLoader.getImgTexture("dxWild")]: TheRave.assetLoader.getTextures(texturePath);
        }
    }

    public onRemove(): void {
        this.destroy({children: true});
    }

    public restoreXS(newSize: number = 1, useGivenSize: boolean = false, delay: number = 0): void {
        if (this.symbolName == "S") {
            return;
        }
        if (useGivenSize) {
            this.symbolSize = newSize;
        } else {
            this.symbolSize *= 2;
        }

        const oldParts = this._symbolPart;
        this._symbolPart = this.createSymbolPart();
        this.getStateAnimation(TheRaveSymbolState.NORMAL, {duration: 0, alpha: 1}, {
            duration: 0,
            alpha: 0
        });
        this.removeSymbolPart(oldParts);
        this._symbolPart.part.alpha = 1;
        if (this._symbolMultiplier > 1) {
            this.addMultiplierOnRestore(this._symbolMultiplier);
        }
    }

    public addSplitSymbolAnimation(newSize: number = 1, useGivenSize: boolean = false, delay: number = 0): TimelineLite {
        if (this.symbolName == "S") {
            return new TimelineLite();
        }

        if (useGivenSize) {
            this.symbolSize = newSize;
        } else {
            this.symbolSize *= 2;
        }
        const tl: TimelineLite = new TimelineLite(),
            oldParts = this._symbolPart;
        this._symbolPart = this.createSymbolPart();
        tl.add(this.getStateAnimation(TheRaveSymbolState.NORMAL, {duration: 0, alpha: 1}, {
            duration: 0,
            alpha: 0
        }), 0);

        tl.add(() => {
            this.removeSymbolPart(oldParts)
        }, this._splitSplashDelay + this._splitSymbolAnimationDuration + delay);
        tl.add(() => {
            this._symbolPart.part.alpha = 1
        }, this._splitSplashDelay + delay);
        return tl;
    }

    public initialWinFrameAnimation(winRation: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            isSmallWin: boolean = winRation < 3,
            isLargeWin: boolean = winRation >= 5,
            frameName:string = this.symbolHeight > 300 ?"L_initialWin_frame" : `${isSmallWin ? "S" : "L"}_initialWin_frame`,
            lightName:string = this.symbolHeight > 300 ?"L_initialLaser": `${isSmallWin ? "S" : (isLargeWin ? "L" : "M")}_initialLaser`,
            frame: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(frameName)),
            lights: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(lightName)),
            animationName: string = `${this.symbolHeight > 300 ? 450 : this.symbolHeight}`;
        frame.name = frameName;
        lights.name = lightName;

        TheRaveHelper.spineAnimationHelper(frame, "initialWinFrame", false);


        tl.add([
            () => {
                //TheRaveHelper.spineAnimationHelper(frame, "initialWinFrame", false);
                //if(this.symbolHeight > 300 ) {
                    //frame.scale.y = 1.5;
                //}
                //Logger.log(`${frame.name} play ${animationName}`)
                //Logger.log(`${lights.name} play ${animationName}`)
                frame.state.setAnimation(0, animationName, false);
                this._symbolPart.part.addChild(frame);
                lights.state.setAnimation(0, animationName, false)
                this._symbolPart.light.addChild(lights);
            }
        ], 0.2);
        tl.add(() => {
            this._symbolPart.part.removeChild(frame);
            this._symbolPart.bg.removeChild(lights);
            frame.destroy();
            lights.destroy();
        }, 1.5);
        return tl;
    }

    public getStagePosition(): PIXI.Point {
        if (this.parent) {
            return new PIXI.Point(this.position.x + this.parent.x,
                this.position.y + this.parent.y);
        }
        return this.position;
    }

    public addMultiplier(multiplierValue: number, animate: boolean = true): TimelineLite {
        this._symbolMultiplier = multiplierValue;
        const tl: TimelineLite = new TimelineLite(),
            multiplierScale: number = this.symbolSize === 1 ? 1 : 0.8,
            part = this._symbolPart;
        part.multipliers = [];
        for (let i: number = 0; i < this.symbolSize; i++) {
            const multiplierText: PIXI.BitmapText = new PIXI.BitmapText("x" + multiplierValue.toString(), part.multiplierStyle);
            (<PIXI.Point>multiplierText.anchor).set(0.5, 1);
            part.multipliers.push(multiplierText);
            tl.add(() => {
                multiplierText.scale.set(multiplierScale, multiplierScale);
                multiplierText.x = -14;
                multiplierText.y = Math.ceil(this.symbolHeight / this.symbolSize) * (i + 1) - this.symbolHeight * 0.5;
                multiplierText.name = "x" + multiplierValue.toString();
            }, 0);
            tl.add(() => {
                part.part.addChild(multiplierText)
            }, animate ? 0.1 : 0);

        }
        return tl;

    }

    public addMultiplierOnRestore(multiplierValue: number): void {
        this._symbolMultiplier = multiplierValue;
        const multiplierScale: number = this.symbolSize === 1 ? 1 : 0.8,
            part = this._symbolPart;
        part.multipliers = [];
        for (let i: number = 0; i < this.symbolSize; i++) {
            const multiplierText: PIXI.BitmapText = new PIXI.BitmapText("x" + multiplierValue.toString(), part.multiplierStyle);
            (<PIXI.Point>multiplierText.anchor).set(0.5, 1);
            part.multipliers.push(multiplierText);

            multiplierText.scale.set(multiplierScale, multiplierScale);
            multiplierText.x = -14;
            multiplierText.y = Math.ceil(this.symbolHeight / this.symbolSize) * (i + 1) - this.symbolHeight * 0.5;

            multiplierText.name = "x" + multiplierValue.toString();
            part.part.addChild(multiplierText)
        }
    }

    private hasBg(): boolean {
        const symType: string = this.symbolName[0];
        return (symType === "M" || symType === "L" || symType === "W" || this.symbolName === "XW");
    }

    public removeLinkedSymbols(): void {
        this._linkedSymbolPart.forEach((part: ISymbolPart) => {
            part.part.visible = false;
            part.bg.visible = false;
        });
    }
}